import axios, { AxiosRequestConfig } from "axios";
import { format } from "date-fns";
import { CustomerDetailInterface, CustomerInterface, CustomerMemo } from "../Objects/Customer";
import { ApiError } from "./ApiError";

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';

export interface getCustomerDetailProps {
    accessKey: string,
    ctmId: number
}
export const getCustomerDetail = async ({
    accessKey,
    ctmId
}: getCustomerDetailProps, config?: AxiosRequestConfig): Promise<CustomerDetailInterface> => {
    try {
        let params = new URLSearchParams()
        params.append("access_key", accessKey)
        params.append("ctm_id", ctmId.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/get_customer_detail',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.data
    } catch (error) {
        throw error
    }
}

export interface SearchCustomerProps {
    searchStr: string
    accessKey?: string
    page: number
    num: number
}
/**
 * getSeed
 * @returns string
 */
export const SearchCustomer = async ({
    searchStr,
    accessKey,
    page,
    num
}: SearchCustomerProps, config?: AxiosRequestConfig): Promise<{ list: CustomerInterface[], rows: number }> => {
    try {
        let params = new URLSearchParams()
        params.append("search_str", searchStr)
        if( accessKey ) {
            params.append("access_key", accessKey)
        }
        params.append("page", page.toString())
        params.append("num", num.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/search_customer',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            list: res.data.data,
            rows: res.data.rows
        }
    } catch (error) {
        throw error
    }
}

export interface editMembershipDataProps {
    ctm_id: number
    ctm_code?: string
    join_date?: Date
    renew_date?: Date
    validity_date?: Date
    access_key?: string
}

export const editMembershipData = async ({
    ctm_id,
    ctm_code,
    join_date,
    renew_date,
    validity_date,
    access_key,
}: editMembershipDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())
        params.append("ctm_code", ctm_code ? ctm_code : "")
        params.append("join_date", join_date ? format(join_date, "yyyy-MM-dd") : "")
        params.append("renew_date", renew_date ? format(renew_date, "yyyy-MM-dd") : "")
        params.append("validity_date", validity_date ? format(validity_date, "yyyy-MM-dd") : "")
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/edit_membership_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface editCustomerDataProps {
    ctm_id: number
    access_key?: string
    ctm_name1?: string
    ctm_name2?: string
    ctm_pronunciation1?: string
    ctm_pronunciation2?: string
    ctm_address1?: string
    ctm_address2?: string
    ctm_address3?: string
    ctm_birthday?: Date
    ctm_gender?: string
    ctm_mail1?: string
    ctm_mail2?: string
    ctm_postcode?: string
    ctm_tel1?: string
    ctm_tel2?: string
}

export const editCustomerData = async ({
    ctm_id,
    access_key,
    ctm_name1,
    ctm_name2,
    ctm_pronunciation1,
    ctm_pronunciation2,
    ctm_address1,
    ctm_address2,
    ctm_address3,
    ctm_birthday,
    ctm_gender,
    ctm_mail1,
    ctm_mail2,
    ctm_postcode,
    ctm_tel1,
    ctm_tel2,
}: editCustomerDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())
        params.append("ctm_name1", ctm_name1 ? ctm_name1 : "")
        params.append("ctm_name2", ctm_name2 ? ctm_name2 : "")
        params.append("ctm_pronunciation1", ctm_pronunciation1 ? ctm_pronunciation1 : "")
        params.append("ctm_pronunciation2", ctm_pronunciation2 ? ctm_pronunciation2 : "")
        params.append("ctm_address1", ctm_address1 ? ctm_address1 : "")
        params.append("ctm_address2", ctm_address2 ? ctm_address2 : "")
        params.append("ctm_address3", ctm_address3 ? ctm_address3 : "")
        params.append("ctm_birthday", ctm_birthday ? format(ctm_birthday, "yyyy-MM-dd") : "")
        params.append("ctm_gender", ctm_gender ? ctm_gender : "")
        params.append("ctm_mail1", ctm_mail1 ? ctm_mail1 : "")
        params.append("ctm_mail2", ctm_mail2 ? ctm_mail2 : "")
        params.append("ctm_postcode", ctm_postcode ? ctm_postcode : "")
        params.append("ctm_tel1", ctm_tel1 ? ctm_tel1 : "")
        params.append("ctm_tel2", ctm_tel2 ? ctm_tel2 : "")
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/edit_customer_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface editCouponDataProps {
    ctm_id: number
    access_key?: string
    edit_point_value: number
}

export const editCouponData = async ({
    ctm_id,
    access_key,
    edit_point_value
}: editCouponDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())
        params.append("edit_point", edit_point_value > 0 ? `+${edit_point_value}` : edit_point_value.toString())
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/edit_coupon_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface regCustomerMemoProps {
    ctm_id: number
    ctm_memo: CustomerMemo[]
    access_key?: string
}
export const regCustomerMemo = async ({
    ctm_id,
    ctm_memo,
    access_key,
}: regCustomerMemoProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())
        ctm_memo.forEach((customerMemo, index) => {
            params.append(`ctm_memo[${index}][ctmmm_id]`, customerMemo.ctmmm_id.toString())
            params.append(`ctm_memo[${index}][ctm_memo]`, customerMemo.ctm_memo)
        })
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/reg_customer_memo',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface deleteMypageProps {
    ctm_id: number
}
export const deleteMypage = async ({
    ctm_id
}: deleteMypageProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/delete_mypage',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface deleteCustomerDataProps {
    ctm_id: number
    access_key?: string
}
export const deleteCustomerData = async ({
    ctm_id,
    access_key,
}: deleteCustomerDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_id", ctm_id.toString())
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/delete_customer_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface registerCustomerProps {
    access_key?: string
    ctm_name1?: string
    ctm_name2?: string
    ctm_pronunciation1?: string
    ctm_pronunciation2?: string
    ctm_address1?: string
    ctm_address2?: string
    ctm_address3?: string
    ctm_birthday?: Date
    ctm_gender?: string
    ctm_mail1?: string
    ctm_mail2?: string
    ctm_postcode?: string
    ctm_tel1?: string
    ctm_tel2?: string
}
export interface registerCustomerResults {
    ctm_id: number
}
export const registerCustomer = async ({
    access_key,
    ctm_name1,
    ctm_name2,
    ctm_pronunciation1,
    ctm_pronunciation2,
    ctm_address1,
    ctm_address2,
    ctm_address3,
    ctm_birthday,
    ctm_gender,
    ctm_mail1,
    ctm_mail2,
    ctm_postcode,
    ctm_tel1,
    ctm_tel2,
}: registerCustomerProps, config?: AxiosRequestConfig): Promise<registerCustomerResults> => {
    try {
        let params = new URLSearchParams()
        params.append("ctm_name1", ctm_name1 ? ctm_name1 : "")
        params.append("ctm_name2", ctm_name2 ? ctm_name2 : "")
        params.append("ctm_pronunciation1", ctm_pronunciation1 ? ctm_pronunciation1 : "")
        params.append("ctm_pronunciation2", ctm_pronunciation2 ? ctm_pronunciation2 : "")
        params.append("ctm_address1", ctm_address1 ? ctm_address1 : "")
        params.append("ctm_address2", ctm_address2 ? ctm_address2 : "")
        params.append("ctm_address3", ctm_address3 ? ctm_address3 : "")
        params.append("ctm_birthday", ctm_birthday ? format(ctm_birthday, "yyyy-MM-dd") : "")
        params.append("ctm_gender", ctm_gender ? ctm_gender : "")
        params.append("ctm_mail1", ctm_mail1 ? ctm_mail1 : "")
        params.append("ctm_mail2", ctm_mail2 ? ctm_mail2 : "")
        params.append("ctm_postcode", ctm_postcode ? ctm_postcode : "")
        params.append("ctm_tel1", ctm_tel1 ? ctm_tel1 : "")
        params.append("ctm_tel2", ctm_tel2 ? ctm_tel2 : "")
        params.append("access_key", access_key ? access_key : "HEAD-OFFICE_LOGIN")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'customer/register_customer',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }

        return {
            ctm_id: parseInt(res.data.ctm_id)
        }
    } catch (error) {
        throw error
    }
}